import memoize           from 'lodash-es/memoize';
import { TooltipParams } from '@/components/chart/chart.types';
import roundNumberFilter from '@/helpers/helpers';

import Format = echarts.EChartOption.Tooltip.Format;

export const useTooltipContent = memoize((content: Format | Format[]): string => {
  const params = content as TooltipParams[];
  let roundNumber: string | number;
  let contentList = '';

  params.forEach((param: TooltipParams) => {
    switch (param.seriesName.split('_')[ 0 ]) {
    case 'SUMRN':
      roundNumber = param.value[ 1 ] !== null ? roundNumberFilter(param.value[ 1 ] as number, 0) : '';
      break;
    case 'MICECONV':
      roundNumber = param.value[ 1 ] !== null ? `${(roundNumberFilter(param.value[ 1 ] as number))}%` : '';
      break;
    default:
      roundNumber = param.value[ 1 ] !== null ? roundNumberFilter(param.value[ 1 ] as number) : '';
    }

    const row = (`
        <div class="c-echarts-tooltip__table__row"
             style="margin-right: ${params.length >= 10 ? '0.8rem' : 0}">

          <span>${param.seriesName}</span>
          <span style="color: ${param.color}">${roundNumber}</span>
        </div>
      `);

    contentList += row;
  });

  return (`
    <div class="c-echarts-tooltip">
      <div class="c-echarts-tooltip__header">
        <span>
         Day ${params[ 0 ].axisValue}
        </span>
      </div>

      <div class="c-echarts-tooltip__table">
        ${contentList}
      </div>

    </div>
  `);
});
